import React from 'react';
import { appConstants } from '../constants';

export default class Image extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <img { ...this.props } src={appConstants.MEDIAPATH + '/' + this.props.src} />
    )
  }
}



// WEBPACK FOOTER //
// ./web-app/components/image.jsx